import { ColumnDef } from "@tanstack/react-table";

import { Checkins } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card/hover-card";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";
import { Button } from "@/components/ui/button/button";

export const columns: ColumnDef<Checkins, any>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => <div className="w-[80px]">{row.index + 1}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "mode",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Mode" />
    ),
    cell: ({ row }) => <div>{row.getValue("mode")}</div>,
    enableColumnFilter: true,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "time",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Time" />
    ),
    cell: ({ row }) => <div>{row.getValue("time")}</div>,
    enableColumnFilter: true,
    enableSorting: false,
    enableHiding: false,
  },

  {
    accessorKey: "workDoneToday",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Note" />
    ),
    cell: ({ row }) => {
      const originData = row.original as Checkins & {
        attachments?: {
          doc: string;
          url: string;
        }[];
      };
      return (
        <div className="flex gap-1 items-center">
          <HoverCard>
            <HoverCardTrigger>{row.getValue("workDoneToday")}</HoverCardTrigger>
            <HoverCardContent>{row.getValue("workDoneToday")}</HoverCardContent>
          </HoverCard>

          {originData?.attachments && originData?.attachments?.length > 0 && (
            <Popover>
              <PopoverTrigger>
                <Button size="sm" variant="outline">
                  Attachments
                </Button>
              </PopoverTrigger>
              <PopoverContent>
                <div className="flex flex-col gap-[2px] items-start">
                  {originData?.attachments?.map((att) => {
                    return (
                      <Button size="sm" variant="link" key={att?.doc} asChild>
                        <a href={att?.url} target="_blank">
                          {att?.doc}
                        </a>
                      </Button>
                    );
                  })}
                </div>
              </PopoverContent>
            </Popover>
          )}
        </div>
      );
    },
    enableColumnFilter: true,
    enableSorting: false,
    enableHiding: false,
  },
];
